module.exports = __webpack_public_path__ + "img/hc_pro_five_4.c49d8dea.jpg";